import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client/react';
import { UPDATE_PLAYER_SEASON } from 'services/mutations';
import styled from 'styled-components';
import { Button } from 'styles';
import { design } from 'utils';
import SeasonSelect from 'Components/Base/SeasonSelect';

const PlayerListWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px 1fr;
  gap: ${design.spacing[2]};
  select:last-child {
    height: 50vh;
    font-size: ${design.fontSizes[2]};
    width: 100%;
  }
  option {
    padding: ${design.spacing[0.5]};
    &:nth-child(2n + 1) {
      background-color: ${design.colors.tertiary};
    }
  }
  button {
    width: 100%;
    padding:;
  }
`;
const ButtonWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  button {
    margin-block: ${design.spacing[2]};
  }
`;
const SelectWrap = styled.div`
  text-align: center;
  select:first-child {
    margin-bottom: ${design.spacing[4]};
  }
`;

const AdminPlayerSeason = ({
  currentSeasonId,
  handleSelectCurrentSeason,
  handleSelectNextSeason,
  nextSeasonId,
  players,
  refetchPlayerData,
  teams,
}) => {
  const [playersToAdd, setPlayersToAdd] = useState([]);
  const [playersToRemove, setPlayersToRemove] = useState([]);
  const [selectedPlayers, setSelectedPlayers] = useState([]);

  const [updatePlayerSeason] = useMutation(UPDATE_PLAYER_SEASON);

  useEffect(() => {
    const currentPlayers = players?.filter(
      (player) => player.lastSeason === nextSeasonId,
    );
    setSelectedPlayers(currentPlayers);
  }, [nextSeasonId, players, teams]);

  const availablePlayers = players?.filter(
    (player) => player.lastSeason !== nextSeasonId,
  );

  const handlePlayersToAdd = (e) => {
    const playerIds = [...e.target.selectedOptions].map((option) =>
      Number(option.value),
    );
    setPlayersToAdd(playerIds);
  };
  const handlePlayersToRemove = (e) => {
    const playerIdsToRemove = [...e.target.selectedOptions].map((option) =>
      Number(option.value),
    );
    setPlayersToRemove(playerIdsToRemove);
  };

  const handleNextSeason = () => {
    const playersNextSeason = playersToAdd.map((playerId) => playerId);
    updatePlayerSeason({
      variables: { players: playersNextSeason, season: nextSeasonId },
    }).then(() => {
      refetchPlayerData();
    });
  };
  const handlePreviousSeason = () => {
    const playersPreviousSeason = playersToRemove.map((playerId) => playerId);
    updatePlayerSeason({
      variables: { players: playersPreviousSeason, season: currentSeasonId },
    }).then(() => {
      refetchPlayerData();
    });
  };

  return (
    <div>
      <form>
        <PlayerListWrap>
          <SelectWrap>
            <SeasonSelect
              isAdmin
              league="GBHPC"
              onChange={handleSelectCurrentSeason}
              value={currentSeasonId}
            />
            <p>Total Players: {availablePlayers.length}</p>
            <p>
              Goalies:{' '}
              {
                [...availablePlayers].filter(
                  (player) =>
                    player.position === 'GOALIE' ||
                    player.positionSecondary === 'GOALIE',
                ).length
              }
            </p>
            <select multiple onChange={handlePlayersToAdd}>
              {availablePlayers?.map((player) => (
                <option value={player.id} key={player.id}>
                  {player.firstName} {player.lastName}
                  {player.position === 'GOALIE' ||
                  player.positionSecondary === 'GOALIE'
                    ? ' (G)'
                    : ''}
                </option>
              ))}
            </select>
          </SelectWrap>
          <ButtonWrap>
            <Button type="button" onClick={handleNextSeason}>
              Add →
            </Button>
            <Button type="button" invert onClick={handlePreviousSeason}>
              ← Remove
            </Button>
          </ButtonWrap>
          <SelectWrap>
            <SeasonSelect
              isAdmin
              league="GBHPC"
              onChange={handleSelectNextSeason}
              value={nextSeasonId}
            />
            <p>Total Players: {selectedPlayers.length}</p>
            <p>
              Goalies:{' '}
              {
                [...selectedPlayers].filter(
                  (player) =>
                    player.position === 'GOALIE' ||
                    player.positionSecondary === 'GOALIE',
                ).length
              }
            </p>
            <select multiple onChange={handlePlayersToRemove}>
              {selectedPlayers?.map((player) => (
                <option value={player.id} key={player.id}>
                  {player.firstName} {player.lastName}
                  {player.position === 'GOALIE' ||
                  player.positionSecondary === 'GOALIE'
                    ? ' (G)'
                    : ''}
                </option>
              ))}
            </select>
          </SelectWrap>
        </PlayerListWrap>
      </form>
    </div>
  );
};

export default AdminPlayerSeason;
